module.exports = __webpack_public_path__ + "static/media/bolt.faf37206.svg";